import React from "react";

const QuizIc = ({ className, fill }) => {
  return (
    <svg
      className={className}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96.000000 96.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,96.000000) scale(0.100000,-0.100000)"
        stroke="none"
      >
        <path
          d="M385 896 c-80 -19 -146 -56 -203 -113 -184 -184 -156 -499 59 -642
85 -57 150 -74 257 -69 113 6 184 33 257 100 256 234 155 635 -182 723 -67 18
-119 18 -188 1z m170 -238 c45 -41 55 -90 30 -142 -10 -20 -31 -44 -46 -52
-20 -10 -29 -22 -29 -39 0 -31 -34 -52 -56 -34 -31 26 -11 92 39 124 35 22 49
73 25 92 -33 26 -57 24 -89 -6 -18 -17 -33 -31 -35 -31 -17 0 -34 16 -34 34 1
45 57 86 117 86 35 0 50 -6 78 -32z m-51 -330 c8 -14 7 -21 -6 -34 -30 -30
-75 9 -48 42 16 18 39 15 54 -8z"
        />
      </g>
    </svg>
  );
};
export default QuizIc;
